import React from "react";
import { GoogleIcon, MicrosoftIcon, GitHubIcon } from "./oauth-icons";

export type OAuthProviderId = "google" | "microsoft" | "github";

export interface OAuthProvider {
  id: OAuthProviderId;
  name: string;
  message: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const OAUTH_PROVIDERS: OAuthProvider[] = [
  {
    id: "google",
    name: "Google",
    message: "Googleアカウントでログインするため、Googleのログイン画面へ移動します。",
    icon: GoogleIcon,
  },
  {
    id: "microsoft",
    name: "Microsoft",
    message: "Microsoftアカウントでログインするため、Microsoftのログイン画面へ移動します。",
    icon: MicrosoftIcon,
  },
  {
    id: "github",
    name: "GitHub",
    message: "GitHubアカウントでログインするため、GitHubのログイン画面へ移動します。",
    icon: GitHubIcon,
  },
];
